"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitListListUploadButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const dialogs_1 = require("../../../../../dialogs");
const validation_1 = require("./dialog/validation");
const popover_1 = require("./dialog/popover");
const WaitListListUploadButton = (props) => {
    const { className, waitListList: { id, contract, root }, disabled, variant, onRefreshPage, } = props;
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const initialValues = {
        items: [],
        listId: id,
    };
    const handleUpload = () => {
        openDialog(dialogs_1.GlobalDialogKeys.WAITLIST_LIST_UPLOAD, initialValues, {
            initialValues,
            refetch: onRefreshPage,
            url: "/wait-list/list/upload",
            validationSchema: validation_1.waitListUploadValidationSchema,
            message: "dialogs.upload",
            testId: "WaitListUploadDialog",
            action: (0, jsx_runtime_1.jsx)(popover_1.WaitListInfoPopover, {}),
            filter: ({ items, listId }) => ({
                listId,
                items: items.map(({ id: _id, ...rest }) => rest),
            }),
            prepareInitialValues: values => values,
            componentProps: {
                selectedItem: initialValues,
            },
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleUpload, icon: icons_material_1.CloudUploadOutlined, message: "form.buttons.upload", className: className, dataTestId: "WaitListListUploadButton", disabled: disabled || !!root || contract.contractStatus !== types_1.ContractStatus.ACTIVE, variant: variant }));
};
exports.WaitListListUploadButton = WaitListListUploadButton;
//# sourceMappingURL=index.js.map